import React from 'react';
const CustomKendoSchedulerContext = React.createContext(null);
export default CustomKendoSchedulerContext;